import { render, staticRenderFns } from "./PositionResultComponent.vue?vue&type=template&id=0e223101&"
import script from "./PositionResultComponent.vue?vue&type=script&lang=js&"
export * from "./PositionResultComponent.vue?vue&type=script&lang=js&"
import style0 from "./PositionResultComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports